(function ($) {
    class PushLogic_Customer_Account {

        constructor() {
            this.vip_form();
            this.change_password_form();
            this.loyalty_resync_form();
            this.init_toggle();
            this.toggle_block();
        }

        getEndpointUrl() {
            const host = window.location.host;
            const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
            const live_endpoint = 'https://shopify.treasuretrails.co.uk';

            if (host == 'treasure-trails-dev.myshopify.com') {
                return dev_endpoint;
            } else if (host == 'treasuretrails.co.uk') {
                return live_endpoint;
            } else {
                return live_endpoint;
            }
        }

        vip_form() {
            var self = this,
                form = $('#pltt-vip-club form');

            if (form.length > 0) {
                var marketing_opt_in = form.find('input[name="marketing_opt_in"]');
                $(marketing_opt_in).on('click', function (e) {
                    e.preventDefault();
                    marketing_opt_in.hide();

                    var customer_id = form.find('input[name="customer_id"]').val(),
                        customer_email = form.find('input[name="customer_email"]').val(),
                        data = {
                            'customer_id': customer_id,
                            'customer_email': customer_email,
                            'marketing_opt_in': marketing_opt_in.val()
                        };

                    self.push_vip_form_data(form, data);
                });
            }
        }

        push_vip_form_data(form, data) {
            var self = this,
                vip_club = form.closest('#pltt-vip-club'),
                webhook_endpoint = '/apps/hub/customer/marketing';

            $.ajax({
                type: 'POST',
                url: webhook_endpoint,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                success: function (response) {
                    if (response.success) {
                        $(vip_club).empty();
                        $('<h3>Thank you for joining our VIP Club. You\'ll receive your 25% off discount code via email shortly.</h3>').appendTo(vip_club);
                    }
                },
                error: function (jqXHR, exception) {
                    console.error('Error occurred:', self.getErrorMessage(jqXHR, exception));
                },
            });
        }

        change_password_form() {
            var self = this,
                form = $('#change-password-form');

            if (form.length > 0) {
                form.on('submit', function (e) {
                    e.preventDefault();
                    var current_password = form.find('#current-password').val(),
                        new_password = form.find('#new-password').val(),
                        confirm_password = form.find('#confirm-password').val(),
                        customer_id = form.find('input[name="customer_id"]').val(),
                        password_message = $('#password-message');

                    if (new_password !== confirm_password) {
                        password_message.text('New password and confirmation do not match.');
                        password_message.css('color', 'red').show();
                        return;
                    }

                    let data = {
                        'customer_id': customer_id,
                        'current_password': current_password,
                        'new_password': new_password
                    };

                    self.push_change_password_form_data(form, data);
                });
            }
        }

        push_change_password_form_data(form, data) {
            var self = this,
                webhook_endpoint = '/apps/hub/customer/password',
                password_message = $('#password-message');

            $.ajax({
                type: 'POST',
                url: webhook_endpoint,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                success: function (response) {
                    if (response.success) {
                        password_message.text('Password changed successfully!').css('color', 'green').show();
                        form[0].reset();
                        form.find('.btn').hide();
                        setTimeout(function () {
                            location.reload();
                        }, 1500);
                    } else {
                        password_message.text('Error changing password: ' + response.error).css('color', 'red').show();
                        form.find('.btn').hide();
                        setTimeout(function () {
                            location.reload();
                        }, 1500);
                    }
                },
                error: function (jqXHR, exception) {
                    console.error('Error occurred:', self.getErrorMessage(jqXHR, exception));
                }
            });
        }

        loyalty_resync_form() {
            var self = this,
                form = $('#pltt-loyalty-resync-form');

            if (form.length > 0) {
                form.on('submit', function (e) {
                    e.preventDefault();
                    var customer_email = form.find('input[name="customer_email"]').val(),
                        data = {
                            'email': customer_email
                        };

                    self.loyalty_resync_form_data(form, data);
                });
            }
        }

        loyalty_resync_form_data(form, data) {
            var self = this,
                container = form.closest('#pltt-loyalty-resync'),
                webhook_endpoint = '/apps/hub/customer/resync';

            $.ajax({
                type: 'POST',
                url: webhook_endpoint,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                success: function (response) {
                    if (response.success) {
                        $(container).empty();
                        $('<p>Your request has been scheduled in a queue. This can take some time depending on how many there are to process, so please check back every hour over the next few hours. If your data hasn\'t regenerated within 24 hours please get in touch with our customer service team so we can investigate further. Thank you!</p>').appendTo(container);
                    }
                },
                error: function (jqXHR, exception) {
                    console.error('Error occurred:', self.getErrorMessage(jqXHR, exception));
                },
            });
        }

        init_toggle() {
            var toggleButtons = document.querySelectorAll('.pltt-toggle');
            toggleButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    var target = button.getAttribute('data-toggle-button');
                    var content = document.querySelector('[data-toggle-content="' + target + '"]');

                    if (content) {
                        if (content.style.display === 'block') {
                            // Collapse the content
                            content.style.maxHeight = content.scrollHeight + 'px'; // Set current height
                            window.setTimeout(function () {
                                content.style.maxHeight = '0'; // Collapse smoothly
                            }, 10);
                        } else {
                            // Expand the content
                            content.style.display = 'block';
                            var contentHeight = content.scrollHeight + 'px'; // Get the height of the content
                            content.style.maxHeight = '0'; // Set initial height to 0
                            window.setTimeout(function () {
                                content.style.maxHeight = contentHeight; // Expand smoothly
                            }, 10); // Delay needed to trigger transition
                        }

                        // Toggle the 'block' and 'none' display state
                        content.addEventListener('transitionend', function () {
                            if (content.style.maxHeight === '0px') {
                                content.style.display = 'none'; // Set display to 'none' after collapse
                            }
                        });
                    }
                });
            });
        }

        toggle_block() {

            var container = $('.pltt-toggle-block');

            $(container).each(function () {

                var current = $(this),
                    table_wrap = current.find('.pltt-table-wrap'),
                    title = current.find('h2'),
                    storage_title = title.text().toLowerCase().replace(' ', '_') + '_open';

                table_wrap.hide();

                if (localStorage.hasOwnProperty(storage_title)) {

                    var is_toggled = localStorage.getItem(storage_title);

                    if (is_toggled == 'yes') {
                        table_wrap.show();
                        current.addClass('pltt-title-toggled');
                    } else {
                        current.removeClass('pltt-title-toggled');
                    }

                }

                $(title).on('click', function () {

                    table_wrap.slideToggle(function () {
                        if ($(this).is(':visible')) {
                            localStorage.setItem(storage_title, 'yes');
                            current.addClass('pltt-title-toggled');
                        } else {
                            localStorage.setItem(storage_title, 'no');
                            current.removeClass('pltt-title-toggled');
                        }
                    });

                });

            });

        }

        getErrorMessage(jqXHR, exception) {
            if (jqXHR.status === 0) {
                return 'Can\'t connect. Verify Network.';
            } else if (jqXHR.status == 404) {
                return 'Requested page not found (404).';
            } else if (jqXHR.status == 500) {
                return 'Internal Server Error (500).';
            } else if (jqXHR.status == 401) {
                return 'Request Unauthorized (401).';
            } else if (exception === 'parsererror') {
                return 'Requested JSON parse failed.';
            } else if (exception === 'timeout') {
                return 'Time out error.';
            } else if (exception === 'abort') {
                return 'Ajax request aborted.';
            } else {
                return 'Uncaught Error.\n' + jqXHR.responseText;
            }
        }
    }

    new PushLogic_Customer_Account();

})(jQuery);